import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MessageRow.html?raw';
//import DataItems = require("DataItems");
import Message from '../../Operations/MessageCenter/Message';
import MessageDisplay from '../MessageCenter/MessageDisplay';

class MessageRow extends compose(_WidgetBaseSP) {
    templateString: any = template;

    data: Message;

    parentWidget: any;

    protected _messageDisplay: MdsLax<InstanceType<typeof MessageDisplay>>;

    styleContainer: HTMLDivElement;
    subjectContainer: HTMLDivElement;
    confirmationIconContainer: HTMLDivElement;

    drawMessage(data?: Message): void {

        if (typeof (data) != "undefined") {
            this.data = data;
        }

        console.debug("MessageRow _drawMessage", this.data);

        // zurücksetzen diverses Knoten, Buttons .... ?
        this.UiModder.domStyle.set(this.subjectContainer, "font-weight", "");
        this.UiModder.domClass.add(this.confirmationIconContainer, "w3-hide");
        this.UiModder.domClass.remove(this.styleContainer, "w3-text-gray w3-khaki");


        // Daten setzen
        if (this.data == null) {
            return;
        }

        // Betreff
        this.subjectContainer.innerHTML = this.data.message_subject_D;

        if (this.data.is_need_confirmation === true && this.data.is_processed != true) {
            this.UiModder.domClass.add(this.styleContainer, "w3-khaki");
            this.UiModder.domClass.remove(this.confirmationIconContainer, "w3-hide");
        }

        if (this.data.is_marked_as_read === true) {
            this.UiModder.domClass.add(this.styleContainer, "w3-text-gray");
        } else {
            
            this.UiModder.domStyle.set(this.subjectContainer, "font-weight", "bold");
        }

        //// Inhalt
        //let content = messageEntry.messageData.message_content_D;
        //this.UiModder.domConstruct.create("div", { "innerHTML": content }, entryRootnode);
    }

    _onClick_Btn_ShowMessage(evt: any): void {
        console.log("MessageRow _onClick_Btn_ShowMessage", this.data);
        if (this.parentWidget != null) {
            if (typeof (this.parentWidget.showMessage) == "function") {
                this.parentWidget.showMessage(this.data.ID);
            }
        }
    }


    protected _setupSubscriptions(): void {
        //this._topics.push(topic.subscribe("Messages/Loaded", lang.hitch(this, this._onMessageListenerLoaded)));
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MessageRow);